import PropTypes from 'prop-types';
import React from 'react';
import {
  Divider,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

const DialogListItem = (
  {
    dataId,
    disabled = false,
    onClick,
    primaryText,
    rightText,
    secondaryText,
  }
) => (
  <div>
    <Divider />
    <ListItem
      button
      data-id={dataId}
      style={{paddingLeft: 0, paddingRight: 0, fontWeight: 500}}
      disabled={disabled}
      onClick={onClick}
    >
      <ListItemText
        primary={primaryText}
        primaryTypographyProps={{variant: 'subtitle2'}}
        secondary={secondaryText}
        secondaryTypographyProps={{component: 'div'}}
      />
      {rightText && (
        <ListItemText
          primary={rightText}
          primaryTypographyProps={{variant: 'subtitle2'}}
          style={{textAlign: 'right', padding: '0px 16px'}}
        />
      )}
      {!disabled && (
        <KeyboardArrowRight />
      )}
    </ListItem>
  </div>
);

DialogListItem.propTypes = {
  dataId: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  primaryText: PropTypes.node,
  rightText: PropTypes.node,
  secondaryText: PropTypes.node,
};

export default DialogListItem;



// WEBPACK FOOTER //
// ./src/ondemand/components/DialogListItem/DialogListItem.js